import React from "react";
import { NotificationManager } from "react-notifications";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import Modal from "react-responsive-modal";
import { CreacionTrasladoAlmacenApi } from "../api/CreacionTrasladoAlmacenApi";
import { useForm } from "react-hook-form";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import moment from "moment";
import { DatosAlmacen } from "./DatosAlmacen";
import NullableValue from "../../../../../Utils/renderField/nullableValue";
import { RenderKilogramo } from "../../../../../Utils/renderField/renderReadField";

export const ConfirmacionTraslado = (props) => {
    const { movimientoSeleccionado, onClose, almacenOrigen, onSuccess } = props;

    const { trasladarMovimiento, cargando } = CreacionTrasladoAlmacenApi();

    const {
        control: formControl,
        getValues: formGetValues,
        trigger: validateForm,
        formState: { errors: formErrors },
    } = useForm({
        mode: "onChange",
    });

    const TrasladarMovimiento = async () => {
        const isValid = await validateForm();
        if (!isValid) return;

        const formValues = formGetValues();

        const almacenDestino = formValues.almacen_destino;

        try {
            const data = {
                movimiento_id: movimientoSeleccionado.movimiento_id,
                almacen_destino_id: almacenDestino.id,
            };

            await trasladarMovimiento(data);

            NotificationManager.success(
                "Traslado creado correctamente",
                "Éxito",
                3000,
            );

            onClose();
            onSuccess();
        } catch (error) {
            console.log(error);
            const errorMsg = getErrorFromResponse(
                error,
                "Error al crear traslado",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    if (!movimientoSeleccionado) return null;

    return (
        <Modal
            open={!!movimientoSeleccionado}
            onClose={onClose}
            closeOnOverlayClick={!cargando}
            focusTrapped={false}
            // aumentar width con style
            styles={{
                modal: {
                    maxWidth: "900px",
                    width: "90%",
                },
            }}
        >
            <LoadMask loading={cargando} blur>
                <h5 className="text-center">Confirmar traslado</h5>

                <DatosAlmacen
                    datosAlmacen={almacenOrigen}
                    formControl={formControl}
                    formErrors={formErrors}
                />

                <h6>Recepción seleccionada</h6>

                <div className="new-table-wrapper creacion-traslado-almacen__table-wrapper">
                    <table className="table-striped">
                        <thead>
                            <tr>
                                <th>Ingreso ID</th>
                                <th>Fecha ingreso</th>
                                <th>Kg húmedos</th>
                                <th>Kg secos laboratorio</th>
                                <th>Kg secos liquidación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={movimientoSeleccionado.movimiento_id}>
                                <td className="text-center text-nowrap">
                                    {movimientoSeleccionado.display_id}
                                </td>
                                <td className="text-center text-nowrap">
                                    {movimientoSeleccionado.fecha_ingreso
                                        ? moment(
                                              movimientoSeleccionado.fecha_ingreso,
                                          ).format("DD/MM/YYYY")
                                        : ""}
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={
                                            movimientoSeleccionado.kg_humedos
                                        }
                                    >
                                        <RenderKilogramo
                                            value={
                                                movimientoSeleccionado.kg_humedos
                                            }
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={
                                            movimientoSeleccionado.kg_secos_lab
                                        }
                                    >
                                        <RenderKilogramo
                                            value={
                                                movimientoSeleccionado.kg_secos_lab
                                            }
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={
                                            movimientoSeleccionado.kg_secos_liq
                                        }
                                    >
                                        <RenderKilogramo
                                            value={
                                                movimientoSeleccionado.kg_secos_liq
                                            }
                                            decimalScale={3}
                                        />
                                    </NullableValue>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="d-flex flex-wrap justify-content-center mt-4 mb-2 gap-1rem">
                    <button
                        className="btn btn-outline-dark"
                        onClick={onClose}
                        disabled={cargando}
                    >
                        Regresar
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={TrasladarMovimiento}
                    >
                        Confirmar traslado
                    </button>
                </div>
            </LoadMask>
        </Modal>
    );
};
